'use client';

import { useCallback, useState } from 'react';

import type { VirtualElement } from '@popperjs/core';
import type { Dispatch, MouseEvent, MouseEventHandler, SetStateAction } from 'react';

export type AnchorEl = null | VirtualElement | Element | (() => VirtualElement);

export const useAnchorEl = (
  initialAnchorEl: AnchorEl = null
): {
  anchorEl: AnchorEl;
  setAnchorEl: Dispatch<SetStateAction<AnchorEl>>;
  handleClose: MouseEventHandler<HTMLElement>;
  handleClick: (event: MouseEvent<HTMLButtonElement>) => void;
  handleMouseEnter: (event: MouseEvent<HTMLButtonElement>) => void;
  handleMouseLeave: (event: MouseEvent<HTMLButtonElement>) => void;
} => {
  const [anchorEl, setAnchorEl] = useState<AnchorEl>( initialAnchorEl );

  const handleClose: MouseEventHandler<HTMLElement> = () => {
    setAnchorEl( null );
  };

  const handleClick: MouseEventHandler<HTMLElement> = (
    event: MouseEvent<HTMLButtonElement>
  ): void => {
    setAnchorEl( event.currentTarget );
  };

  const handleMouseEnter: MouseEventHandler<HTMLElement> = useCallback(
    (event: MouseEvent<HTMLElement>): void => {
      setAnchorEl( event.target as AnchorEl );
    },
    []
  );

  const handleMouseLeave: MouseEventHandler<HTMLElement> = (): void => {
    setAnchorEl( null );
  };

  return {
    anchorEl,
    setAnchorEl,
    handleClose,
    handleClick,
    handleMouseEnter,
    handleMouseLeave,
  };
};
